import React from "react";

export function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 9.5V4H11V11.5L7 15.5L8.5 17L13 12.5V9.5Z"
        fill="black"
      />
      <path opacity="0.8" d="M13 4H11V11.5L13 9.5V4Z" fill="black" />
      <path d="M8.5 17L7 15.5L13 9.5V12.5L8.5 17Z" fill="black" />
    </svg>
  );
}
